export const logoutReasonLocalStorageKey = 'logoutReason';

export const cookieNameDefaultTemplateDialogWasShown = 'defaultTemplateDialogWasShown';

export const dropzoneEventAdded = 'added';
export const dropzoneEventRemoved = 'removed';

export const externalServiceProviderFacebook = 'facebook';
export const externalServiceProviderGoogle = 'google';

export const endpointEmailVerification = 'confirmEmail';

export const endpointDeleteSupplierForUser = 'deleteSupplierForUser';
export const endpointCreateSupplierForUser = 'createSupplierForUser';

export const endpointGetExternalServiceAuthUrl = 'getLoginServiceAuthorizeUrl';
export const endpointLoginWithExternalService = 'loginWithExternalService';

export const googleCallbackRoute = 'googlecallback';
export const facebookCallbackRouter = 'fbcallback';

export const listSelectionStorageKey = 'listSelections';
export const documentListOrderStorageKey = 'documentListOrder';

export const endpointGenerateNewApiKey = 'generateNewApiKey';
export const endpointSaveApiKeyData = 'saveApiKeyData';
export const endpointUpdatePlan = 'updatePlan';
export const endpointGetApiKeysList = 'getApiKeysList';
export const endpointDeleteApiKey = 'deleteApiKey';
export const endpointDeleteManyApiKeys = 'deleteManyApiKeys';
export const endpointUpdateUserConfiguration = 'updateUserConfiguration';
export const endpointDisableApiKeys = 'systemDisableApiKeys';
export const endPointSplitDocument = 'splitDocument';
export const endPointMergeDocuments = 'mergeDocument';
export const endPointJsonExportDocument = 'jsonExportDocument';
export const changeApiKey = 'changeApiKey';

export const apiDocumentationUrl = 'https://api.scandocflow.com/?version=latest';

export const dataValidityKey = 'dataIsValid';
export const dataIsValidAfterSave = 'validAfterSave';
export const dataIsValidAfterDelete = 'validAfterDelete';
export const dataIsValidAffectedIds = 'affectedIds';

export const realtimeSagaAfterSaveAction = 'afterSave';
export const realtimeSagaAfterDeleteAction = 'afterDelete';

export const invalidateDataEvent = 'INVALIDATE_DATA';
export const recognitionLimitExceedEvent = 'RECOGNITION_LIMIT_EXCEEDED';
export const toggleDefaultTemplateDialogEvent = 'TOGGLE_DEFAULT_TEMPLATE_DIALOG';
export const exportEvent = 'EXPORT';

export const realtimeSagaExportEndedAction = 'exportEnded';
export const realtimeSagaRecognitionLimitExceededAction = 'recognitionLimitExceeded';
export const realtimeSagaToggleDefaultTemplateDialog = 'toggleDefaultTemplateDialog';

export const realtimeDataReducerKey = 'realtimeData';

export const statusPaid = 'paid';
export const statusUnpaid = 'unpaid';

export const statusApprovalApproved = 'Verified';
export const statusApprovalNotVerified = 'Not verified';

export const siteUrlAbout = 'https://scandocflow.com/about-us';
export const siteUrlFAQ = 'https://scandocflow.com/faq';
export const siteUrlWhatsNew = 'https://scandocflow.com/whats-new';
export const siteUrlTerms = 'https://scandocflow.com/terms-and-conditions';
export const siteUrlPrivacy = 'https://scandocflow.com/privacy-policy/';

export const mailtoSupport = 'mailto:support@scandocflow.com';

export const archivedStatus = 1;
export const unarchivedStatus = 0;

export const waitingRecognitionStatus = 'Waiting';
export const recognizingRecognitionStatus = 'Recognizing';
export const doneRecognitionStatus = 'Done';
export const errorRecognitionStatus = 'Error';

export const documentRecordDataPath = 'fields.data';

export const recognitionStatuses = [
    {id: waitingRecognitionStatus, name: waitingRecognitionStatus},
    {id: recognizingRecognitionStatus, name: recognizingRecognitionStatus},
    {id: doneRecognitionStatus, name: doneRecognitionStatus},
    {id: errorRecognitionStatus, name: errorRecognitionStatus},
];

export const endpointLogin = 'login';
export const endpointLogout = 'logout';

export const resourceMenuDocumentTypes = 'menuDocumentTypes';
export const resourceDocuments = 'documents';
export const resourceUserDocuments = 'userDocuments';
export const resourceDocumentHistory = 'documentHistories';
export const resourceTemplates = 'templates';
export const resourceTemplateCollections = 'templateCollections';
export const endpointDownloadBatch = 'downloadBatch';
export const resourceUsers = 'users';  // has loads of includes in addUpload feature in contrast to resourceCustomUsers
export const resourceProfile = 'profile';
export const resourceTags = 'tags';
export const resourcePlan = 'plan';
export const resourceSuppliers = 'suppliers';
export const resourceSupplier = 'supplier';
export const resourceFileFormat = 'fileFormats';
export const resourceStatistics = 'statistics';
export const resourceRequests = 'requests';
export const resourcePlanHistories = 'planHistories';
export const resourceRecognitionBonuses = 'recognitionBonuses';
export const resourcePlans = 'plans';
export const resourceUserHistory= 'userHistory';
export const resourceRules = 'rules';
export const resourceRuleConfig = 'ruleConfigs';
export const resourceIntegrationCredentials = 'integrationCredentials';
export const resourceIntegrations = 'integrations';
export const resourceExportConfig = 'exportConfigs';
export const resourceDocumentTypes = 'documentTypes';
export const resourceCurrencies = 'currencies';
export const resourceOcrLanguage = 'ocrLanguages';

export const templateCollectionResource = 'templateCollection';
export const templateCollectionsResource = 'templateCollections';
export const resourceConfiguration = 'configuration';
export const resourceConfigurations = 'configurations';
export const supplierResource = 'supplier';
export const rulesResource = 'exportRules';
export const resourceCustomUsers = 'customUsers'; // has no includes in addUpload feature in contrast to resourceUsers
export const resourceApiKey = 'apiKeys';

export const relationRole = 'roleRelation';
export const relationSubscriptionPlanData = 'subscriptionPlanData';
export const relationFilesAuthParams = 'filesAuthParams';
export const relationOriginDocumentsCount = 'originDocumentsCount';
export const relationUser = 'user';
export const relationDocumentType = 'documentType';
export const fakeRelationNumberOfRequests = 'numberOfRequests';

export const searchSourceNameKey = 'searchSourceNameKey';
export const querySearch = 'searchString';

export const collectionIdDefault = 'default';

export const uploadFilesEndpoint = 'uploadFiles';
export const applyFieldCalculationsEndPoint = 'applyFieldCalculations';

export const getPrevNextEndPoint = 'prevNext';

export const sendForgotPasswordLetterEndPoint = 'sendForgotPasswordLetter';
export const changePasswordEndPoint = 'changePassword';
export const resetPasswordEndPoint = 'resetPassword';
export const resetPasswordConfirm = 'resetPasswordConfirm';
export const changePasswordAdminEndPoint = 'changePasswordAdmin';

export const defaultLanguage = 'eng';

export const space = ' ';
export const prefixForManualLoadedDocument = 'manual ';
export const applicationJson = 'application/json';

export const lineItemPrefix = 'lineItem';
export const lineItemRowIndexKey = 'rowIndex';
export const lineItemCheckKey = 'check';

export const statStatusError = 'error';
export const statStatusUploading = 'uploadingDocuments';
export const statStatusFinished = 'receivedRecognitionResponse';
export const statStatusWaiting = 'waitingForRecognitionResponse';

export const statisticsStatusMatching = {
    [statStatusError]: 'statistics.statuses.error',
    [statStatusFinished]: 'statistics.statuses.receivedRecognitionResponse',
    [statStatusUploading]: 'statistics.statuses.uploadingDocuments',
    [statStatusWaiting]: 'statistics.statuses.waitingForRecognitionResponse'
};

export const DEFAULT_FORM_NAME = 'simple-form';
export const TEMPLATE_FORM_NAME = 'template-edit-form';
export const DOCUMENT_FORM_NAME = 'document-edit-form';

export const lastFocusedFieldKey = 'lastFocusedField';

export const accessTokenLocalStorageKey = 'lbtoken';

export const lineItemsDragDropReducerKey = 'lineItemsDragDrop';
export const lineItemsDoingDragDrop = 'LINE_ITEMS_DRAG_DROP';

export const recognitionStatus = 'status';
export const recognitionMessage = 'message';

export const userId = 'userId';
export const username = 'username';
export const fullName = 'fullName';
export const email = 'email';

export const oldDataHistory = 'old';
export const newDataHistory = 'new';
export const historyDateToFunction = ['invoiceDateEpoch', 'invoiceDueDateEpoch', 'recognizingFinished', 'fields.data.date', 'fields.data.dueDate', 'uploadDate', 'recognizingStarts', 'date'];

export const actionTypeEditData = 'editData';
export const actionTypeExport = 'export';
export const actionTypeStatusChanged = 'statusChanged';
export const actionTypeUploadingDocument = 'uploading';
export const actionTypeTagsChanged = 'tagsChanged';
export const actionTypeRecognitionResponse = 'recognitionResponse';
export const actionTypeRecognitionResponseError = 'recognitionResponseError';
export const actionTypeCreatedAfterRecognition = 'creationAfterRecognition';
export const actionTypeSendToRecognition = 'sendToRecognition';
export const actionTypeSendToRecognitionFailed = 'sendToRecognitionFailed';
export const actionTypeRecognitionTimeout = 'recognitionTimeout';
export const actionTypeCalculateFields = 'calculateFields';

export const monthFilterKey = 'month';
export const dayFilterKey = 'day';

export const exportStatus = 'exportStatus';
export const exportErrorMessage = 'errorMsg';

export const exportPublishedTo = 'publishedTo';
export const exportPublishedAs = 'publishedAs';
export const exportDocumentId = 'documentId';

export const endpointHealthy = 'health';

// Formats for dateformat package https://www.npmjs.com/package/dateformat
export const date = 'dd/mm/yyyy';
export const dateTime = 'dd/mm/yyyy HH:MM';
export const yearAndWeek = 'yyyy/W';
export const dateFormat = 'dd/mm/yyyy';
export const dateTimeFormat = 'dd/mm/yyyy HH:MM';
export const dateTimeSecondsFormat = 'dd/mm/yyyy HH:MM:ss';

export const xeroInvoiceIdLocalStorageKey = 'invoiceId';
export const xeroInvoiceIdManyLocalStorageKey = 'invoicesIds';
export const xeroTypeOfExportLocalStorageKey = 'typeOfExport';
export const xeroCountTypeOfExportLocalStorageKey = 'countOfExport';
export const xeroAccessTokenLocalStorageKey = 'accessToken';
export const xeroOptionsLocalStorageKey = 'xeroOptions';

export const xeroTotalTypeOfExport = 'total';
export const xeroItemsTypeOfExport = 'items';

export const xeroSingleTypeOfExport = 'single';
export const xeroManyTypeOfExport = 'many';

export const xeroExportStep2Endpoint = 'exportToXeroStep2';
export const xeroExportSingleEndpoint = 'exportToXero';
export const xeroExportManyEndpoint = 'exportBatchToXero';
export const xeroExportOptionsEndpoint = 'xeroExportOptions';

export const xeroCallbackUrl = 'xeroCallback';
export const xeroStatusKey = 'xeroStatus';
export const xeroErrorMsg = 'xeroErrorMsg';

export const xeroIntegrationStatusEnabled = true;
export const xeroIntegrationStatusDisabled = false;

export const xeroRedirectToLocalStorageKey = 'returnTo';
export const integrationConnectionMessageLocalStorageKey = 'integrationConnectionMessage';
export const integrationConnectionRedirectPathLocalStorageKey = 'integrationConnectionRedirectPath';

export const documentTypeIdRegexp = '[a-z]{1}[\\w\\.]*'; // Change only together with documentTypeIdValidationRegexp
export const documentTypeIdValidationRegexp = /^[a-z][\w.]*$/g;

export const defaultTemplateData = {
    'Alias': '',
    'Descriptors': {
        'SupplierName': '',
    },
    'Tags': {
        'KeyWords': []
    },
    'Constraints': {
        'Any': [],
        'Prefix': [],
        'vPrefix': [],
        'InLine': [],
        'SubLine': [],
        'EntireLine': [],
        'UpDown': []
    },
    'TextTables': [
        {
            'Name': 'LineItems',
            'Header': [
                'Description',
                'Qty',
                'UnitPrice',
                'Total'
            ],
            'Cells': [
                '{Description:text:}',
                '{Qty:decimal:}',
                '{UnitPrice:decimal:}',
                '{Total:decimal:}'
            ]
        }
    ],
    'Info': {
        'InstanceId': '176'
    }
};

export const ocrSplittingEngineAuto = 'Auto';
export const ocrSplittingEngineToOnePage = 'OneToOne';
export const ocrSplittingEngineDoNotSplit = 'AllToOne';

export const splittingEngine = [
    {id: ocrSplittingEngineAuto, name: 'Auto'},
    {id: ocrSplittingEngineToOnePage, name: 'Split to one pages'},
    {id: ocrSplittingEngineDoNotSplit, name: 'Do not split'}
];

export const ocrProviderTesseract = 'Tesseract';
export const ocrProviderAzure = 'Azure';
export const ocrProviderGoogle = 'Google';
export const ocrProviderTextract = 'Textract';
export const ocrProviderUserDefined = 'userDefined';

export const ocrProviders = [
    {id: ocrProviderTesseract, name: ocrProviderTesseract},
    {id: ocrProviderAzure, name: ocrProviderAzure},
    {id: ocrProviderGoogle, name: ocrProviderGoogle},
    {id: ocrProviderTextract, name: ocrProviderTextract}
];

export const roleAdmin = 'admin';
export const roleOperator = 'operator';
export const roleUser = 'user';

export const roles = [
    {id: roleAdmin, name: 'Admin'},
    {id: roleOperator, name: 'Operator'},
    {id: roleUser, name: 'User'}
];

export const planEndingYearly = '-yearly';

export const planStandardOcr = 'standard-ocr';
export const planAdvancedOcr = 'advanced-ocr';
export const planDataExtraction = 'data-extraction';

export const planAdmin = 'unlimited';
export const planFree = 'free';

export const planStandardOcrYearly = `${planStandardOcr}${planEndingYearly}`;
export const planAdvancedOcrYearly = `${planAdvancedOcr}${planEndingYearly}`;
export const planDataExtractionYearly = `${planDataExtraction}${planEndingYearly}`;

export const plans = [
    {id: planFree, name: planFree},
    {id: planStandardOcr, name: planStandardOcr},
    {id: planAdvancedOcr, name: planAdvancedOcr},
    {id: planDataExtraction, name: planDataExtraction},
    {id: planStandardOcrYearly, name: planStandardOcrYearly},
    {id: planAdvancedOcrYearly, name: planAdvancedOcrYearly},
    {id: planDataExtractionYearly, name: planDataExtractionYearly},
    {id: planAdmin, name: planAdmin},
];

export const exportOptions = [
    {id: 'true', name: 'Exported'},
    {id: 'false', name: 'Not Exported'}
];

export const ocrProviderPdfTexts = [
    {id: 'auto', name: 'auto'},
    {id: 'always', name: 'always'},
    {id: 'never', name: 'never'},
];

export const documentFieldTypeText = 'text';
export const documentFieldTypeLongText = 'long text';
export const documentFieldTypeDate = 'date';
export const documentFieldTypeNumber = 'number';
export const documentFieldTypeCurrencyNumber = 'currency number';
export const documentFieldTypeBoolean = 'boolean';
export const documentFieldTypeCurrency = 'currency';
export const documentFieldTypeFlatTable = 'flatTable';
export const documentFieldTypeSupplier = 'supplier';
export const documentFieldTypeOcrText = 'ocrText';
export const documentFieldTypeSeverityLevel = 'severityLevel';
export const documentFieldTypeUserSeverityLevel = 'userSeverityLevel';
export const documentFieldCalculatedSeverityLevel = 'calculatedSeverityLevel';
export const documentFieldMaxSeverityLevel = 'maxSeverityLevel';
export const documentFieldStatusApproval = 'statusApproval';

export const responseFieldTypeString = 'string';
export const responseFieldTypeDate = 'date';
export const responseFieldTypeDecimal = 'decimal';
export const responseFieldTypeFlatTable = 'flatTable';
export const responseFieldTypeBoolean = 'boolean';

export const urlHashHighlightsPrefix = 'highlights-';
export const urlHashSplitSymbol = '_';

export const responseTypesDefaultValues = {
    [responseFieldTypeString]: '',
    [responseFieldTypeDecimal]: 0.0,
    [responseFieldTypeDate]: null
};

export const documentTypeChoices = [
    {id: documentFieldTypeText, name: 'documentTypes.field_types.text'},
    {id: documentFieldTypeLongText, name: 'documentTypes.field_types.long_text'},
    {id: documentFieldTypeDate, name: 'documentTypes.field_types.date'},
    {id: documentFieldTypeNumber, name: 'documentTypes.field_types.number'},
    {id: documentFieldTypeCurrencyNumber, name: 'documentTypes.field_types.currencyNumber'},
    {id: documentFieldTypeCurrency, name: 'documentTypes.field_types.currency'},
    {id: documentFieldTypeFlatTable, name: 'documentTypes.field_types.flat_table'},
    {id: documentFieldTypeSupplier, name: 'documentTypes.field_types.supplier'},
    {id: documentFieldTypeOcrText, name: 'documentTypes.field_types.ocr_text'},
];

export const documentEditDelimiterPositionKey = 'documentDelimiterPosition';
export const headerTabDataSource = 'fields';

export const userTourStepChooseDocumentType = 0;
export const userTourStepOpenDocumentUploading = 1;
export const userTourStepUploadDocument = 2;
export const userTourStepWaitForRecognition = 3;
export const userTourStepGoToDocumentEdit = 4;
export const userTourStepCongratulations = 5;

export const endpointSyncIntegrationData = 'syncIntegrationData';
export const endpointGetAuthorizeUrl = 'getAuthorizeUrl';
export const endpointDisconnectFromIntegration = 'disconnectFromIntegration';
export const endpointConnectToIntegration = 'connectToIntegration';
export const endpointSubmitAdditionalConnectionData = 'submitAdditionalConnectionInfo';
export const endpointExportDocuments = 'exportDocuments';
export const endpointGetUserAllowedUploadingCount = 'getAllowedUploadingCount';
export const endpointPlanInfo = 'planInfo';
export const endpointSendVerificationLetter = 'sendVerificationLetter';

export const integrationExportAsHeaders = 'headers';
export const integrationExportAsLineItems = 'lineItems';

export const integrationOptionExportAsChoices = [
    {id: integrationExportAsHeaders, name: 'integrations.export_as.headers'},
    {id: integrationExportAsLineItems, name: 'integrations.export_as.line_items'},
];

export const ruleConfigOptionsFieldTypeAutocomplete = 'autocomplete';
export const ruleConfigOptionsFieldTypeAutocompleteWithCreate = 'creatableAutocomplete';
export const ruleConfigOptionsFieldTypeRadio = 'radio';
export const ruleConfigOptionsFieldTypeBoolean = 'boolean';

export const mimeTypesMapping = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg', '.jfif', '.pjpeg', '.pjp'],
    'image/gif': ['.gif'],
    'application/pdf': ['.pdf'],
    'image/tiff': ['.tif', '.tiff'],
    'application/vnd.ms-excel': ['.xls'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'image/bmp': ['.bmp'],
    'image/x-ms-bmp': ['.x-ms-bmp'],
    'application/rtf': ['.rtf']
};

export const integrationNameXero = 'Xero';
export const integrationNameACS = 'AccountingSuite';
export const integrationNameQB = 'QuickBooks';
export const integrationNameFreshBooks = 'FreshBooks';

export const fieldsMappingTab = 'fieldsMapping';
export const stagesConfigTab = 'stagesConfig';
export const commonDataTab = 'commonData';

export const freeRecognitionsPeriod = 30 * 24 * 60 * 60 * 1000;

export const ocrProvidersWithDefault = [
    {id: ocrProviderUserDefined, name: 'documentTypes.fields.user_defined'},
    ...ocrProviders
];

export const jsonEditorModeCode = 'code';
export const jsonDataType = 'json';
export const stringDataType = 'string';

export const constrainsKeys = ['vPrefix', 'Prefix', 'Any'];

export const severityLevels: Record<string, number> = {
    passed: 0,
    info: 2,
    warning: 5,
    critical: 9,
};

export const userSeverityLevels: Record<string, number> = {
    passed: 0,
    info: 2,
    warning: 5,
    failed: 9
};

export const severityLevelsColors: Record<string, string> = {
    passed: '#51de5e',
    info: '#0099cc',
    warning: '#ffbb33',
    critical: '#d71010',
    failed: '#d71010', // for user view
    empty: 'gray'
};

export const historyCategories = {
    USER: 'user',
    API_KEY: 'api_key',
    DOCUMENT: 'document',
    DOCUMENT_TYPE: 'document_type',
    SUPPLIER: 'supplier',
    TEMPLATE: 'template',
    TEMPLATE_COLLECTION: 'template_collection'
};

export const historyTypes = {
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    REGISTER: 'register',
    LOGIN: 'login',
    LOGOUT: 'logout',
    CHANGE_PASSWORD: 'change_password',
    DISABLE: 'disable',
    EXPORT_TO_XERO: 'export_to_xero'
};

export const requestStatusError = 'error';
export const requestStatusSuccess = 'success';
export const requestStatusRunning = 'running';
export const webhookStatusNotSent = 'notSent';

export const customTokenSourceApiAsync = 'apiAsync';
export const customTokenSourceApiSync = 'apiSync';
export const customTokenSourceWeb = 'web';

export const intervalHour = 'hour';
export const intervalDay = 'day';
export const intervalWeek = 'week';
export const intervalMonth = 'month';

export const requestsStatisticsEndPoint = 'requestsStatistics';

export const defaultSelectionKey = 'default';

export const mapRuleToFieldExtended = (rule: {resultName: string, resultType: string}) => {
    return {
        name: rule.resultName,
        type: {
            class: rule.resultType,
            extended: true,
        },
    };
};

export const mapRuleToFieldSimple = (name: string, typeClass: string) => {
    return {
        name: name,
        type: {
            class: typeClass,
            extended: false,
        }
    };
};

export const numberToSeverityString = (value: number) => {
    let textValue = Object.keys(userSeverityLevels).find(key => userSeverityLevels[key] === value);
    if (!textValue) {
        textValue = 'empty';
    }

    return textValue;
};
